/**
 * Décodeur du format Server-Sent Events, sans dépendance.
 *
 * POURQUOI PAS `EventSource` : il n'accepte aucun en-tête, donc pas notre
 * `Authorization: Bearer`. Il aurait fallu mettre le jeton dans l'URL, où il finit dans
 * les journaux de nginx. On lit donc le flux avec `fetch`, et ce décodeur fait ce que le
 * navigateur aurait fait.
 *
 * Fonction pure, testée seule (`evenementsServeur.test.js`) : un morceau de réseau peut
 * couper un événement n'importe où, le reste est rendu pour le morceau suivant.
 *
 * @param {string} tampon  ce qui a été reçu et pas encore décodé
 * @returns {{ evenements: Array<{nom: string, donnees: any}>, reste: string }}
 *          Les commentaires (`: battement`) produisent un événement `battement`, pour
 *          que l'appelant sache que le flux est vivant.
 */
export function lireEvenements(tampon) {
  const normalise = tampon.replace(/\r\n/g, '\n');
  const blocs = normalise.split('\n\n');
  const reste = blocs.pop();
  const evenements = [];
  for (const bloc of blocs) {
    let nom = 'message';
    const lignes = [];
    let commentaire = false;
    for (const ligne of bloc.split('\n')) {
      if (ligne.startsWith(':')) { commentaire = true; continue; }
      const deuxPoints = ligne.indexOf(':');
      const champ = deuxPoints === -1 ? ligne : ligne.slice(0, deuxPoints);
      const valeur = deuxPoints === -1 ? '' : ligne.slice(deuxPoints + 1).replace(/^ /, '');
      if (champ === 'event') nom = valeur;
      else if (champ === 'data') lignes.push(valeur);
    }
    if (lignes.length) {
      const brut = lignes.join('\n');
      let donnees = brut;
      try { donnees = JSON.parse(brut); } catch { /* texte brut, rendu tel quel */ }
      evenements.push({ nom, donnees });
    } else if (commentaire) {
      evenements.push({ nom: 'battement', donnees: null });
    }
  }
  return { evenements, reste };
}

/** Un lot d'actifs touche-t-il ce qui est affiché ? `*` veut dire « relis tout ». */
export function lotConcerne(lot, idsAffiches) {
  const actifs = lot?.actifs || [];
  if (actifs.includes('*')) return true;
  return actifs.some(id => idsAffiches.has(id));
}

/**
 * Quand relire, compte tenu de la relecture précédente et d'une relecture déjà prévue.
 *
 * Rend l'instant cible, ou `null` s'il faut garder la relecture déjà programmée (elle
 * arrive aussi tôt ou plus tôt). Une demande plus urgente avance l'échéance ; une moins
 * urgente ne la recule jamais.
 */
export function echeanceRelecture({ maintenant, derniere, ecartMs, prevue = null }) {
  const cible = Math.max(maintenant, derniere + ecartMs);
  if (prevue !== null && prevue <= cible) return null;
  return cible;
}
